module.exports = __webpack_public_path__ + "static/img/brandon.76f0af6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/brandon.jpg
// module id = UFlt
// module chunks = 0